import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Cross from '@deliveroo/icon-set/react/Cross';
import Icon from '@deliveroo/consumer-component-library/components/Icon';
import P from '@deliveroo/consumer-component-library/components/P';
import Spacer from '@deliveroo/consumer-component-library/components/Spacer';
import UnstyledButton from '@deliveroo/consumer-component-library/components/UnstyledButton';

import i18n from '../../utils/i18n';
import { urlWithLocale } from '../../utils/locale';
import { maybeSetClientCookie } from '../../utils/cookies/client';

import { Container } from '../../atoms';
import styles from './styles.scss';

export const COOKIE_BANNER_ID = 'cookie-banner';

export class CookieBanner extends Component {
  constructor(props) {
    super(props);
    this.state = { seenCookieMessage: this.props.seenCookieMessage };
    this.dismiss = this.dismiss.bind(this);
  }

  componentDidMount() {
    if (typeof window !== 'undefined') {
      window.isOneTrustCookieConsentEnabled = false;
    }

    if (!this.state.seenCookieMessage) {
      maybeSetClientCookie('seen_cookie_message', 't', { path: '/', expires: 365 });
    }
  }

  dismiss() {
    this.setState({ seenCookieMessage: true });
  }

  render() {
    if (this.state.seenCookieMessage) {
      return null;
    }

    const { currentCountry, locale } = this.props;

    const cookiesUrl = urlWithLocale(currentCountry, '/cookies', locale);

    return (
      <div className={styles.outerContainer} id={COOKIE_BANNER_ID}>
        <Container>
          <div className={styles.innerContainer}>
            <P size="regular" color="white">
              {/* eslint-disable react/no-danger */}
              <span
                dangerouslySetInnerHTML={{
                  __html: i18n.gettext('cookie_banner %(cookies_url)s', {
                    cookies_url: cookiesUrl,
                  }),
                }}
              />
              {/* eslint-enable react/no-danger */}
            </P>
            <Spacer spacing="0 0 0 small">
              <UnstyledButton onClick={() => this.dismiss()}>
                <Icon component={Cross} size={24} color="white" />
              </UnstyledButton>
            </Spacer>
          </div>
        </Container>
      </div>
    );
  }
}

CookieBanner.propTypes = {
  seenCookieMessage: PropTypes.bool.isRequired,
  currentCountry: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  locale: PropTypes.string.isRequired,
};

export default connect((state) => ({
  seenCookieMessage: state.request.seenCookieMessage,
  currentCountry: state.request.country,
  locale: state.request.locale,
}))(CookieBanner);
